(function () {
  if (window.MN3_CHROME) return;
  window.MN3_CHROME = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var lastFocus = null;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openLayer(el, focusSel) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = focusSel ? $(focusSel, el) : null;
    if (f) setTimeout(function () { f.focus(); }, 30);
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var countTimer;
  function refreshCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          $$('[data-mn3-cart-count]').forEach(function (el) {
            el.textContent = c.item_count;
            el.hidden = !c.item_count;
          });
        }).catch(function () {});
    }, 150);
  }
  window.MN3_refreshCartCount = refreshCount;

  function watchBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && 'MutationObserver' in window) {
      new MutationObserver(refreshCount).observe(bubble, { childList: true, subtree: true, characterData: true });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(refreshCount).observe(drawer, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBubble); else watchBubble();
  document.addEventListener('cart:updated', refreshCount);
  document.addEventListener('cart:refresh', refreshCount);

  var money = function (v) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var n = parseFloat(v);
    if (isNaN(n)) return v;
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  };

  var timer;
  function runSearch(q) {
    var box = $('[data-mn3-results]');
    var head = $('[data-mn3-search-head]');
    if (!box) return;
    if (!box.dataset.initial) box.dataset.initial = box.innerHTML;
    if (!q) { box.innerHTML = box.dataset.initial; if (head) head.textContent = 'Beliebte Produkte'; return; }
    fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        if (head) head.textContent = list.length === 1 ? '1 Treffer' : list.length + ' Treffer';
        box.innerHTML = '';
        list.forEach(function (p) {
          var a = document.createElement('a');
          a.className = 'mn3-sr';
          a.href = p.url;
          var img = document.createElement('img');
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          if (p.image) img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          var t = document.createElement('span'); t.className = 'mn3-sr__t'; t.textContent = p.title;
          var pr = document.createElement('span'); pr.className = 'mn3-sr__p'; pr.textContent = money(p.price);
          a.appendChild(img); a.appendChild(t); a.appendChild(pr);
          box.appendChild(a);
        });
      }).catch(function () {});
  }

  function closeMegas(except) {
    $$('[data-mn3-mega]').forEach(function (m) {
      if (m === except) return;
      var p = $('[data-mn3-mega-panel]', m), b = $('[data-mn3-mega-toggle]', m);
      if (p) p.hidden = true;
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var mt = t.closest('[data-mn3-mega-toggle]');
    if (mt) {
      var m = mt.closest('[data-mn3-mega]');
      var p = $('[data-mn3-mega-panel]', m);
      var open = p.hidden;
      closeMegas(m);
      p.hidden = !open;
      mt.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!t.closest('[data-mn3-mega]')) closeMegas();

    if (t.closest('[data-mn3-menu-open]')) { e.preventDefault(); var b = t.closest('[data-mn3-menu-open]'); b.setAttribute('aria-expanded', 'true'); openLayer($('[data-mn3-drawer]'), '[data-mn3-menu-close].mn3-hdr__icon'); return; }
    if (t.closest('[data-mn3-menu-close]')) { e.preventDefault(); $$('[data-mn3-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); closeLayer($('[data-mn3-drawer]')); return; }
    if (t.closest('[data-mn3-search-open]')) { e.preventDefault(); openLayer($('[data-mn3-search]'), '[data-mn3-q]'); return; }
    if (t.closest('[data-mn3-search-close]')) { e.preventDefault(); closeLayer($('[data-mn3-search]')); return; }
    var chip = t.closest('[data-mn3-chip]');
    if (chip) { e.preventDefault(); var q = $('[data-mn3-q]'); if (q) { q.value = chip.getAttribute('data-mn3-chip'); runSearch(q.value); } return; }
    if (t.closest('[data-mn3-cart]')) {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.toggleDrawerClasses === 'function' && d.dataset.cartType !== 'page') {
        e.preventDefault();
        if (!d.isOpen) d.toggleDrawerClasses();
      }
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-mn3-q]')) {
      clearTimeout(timer);
      var v = e.target.value.trim();
      timer = setTimeout(function () { runSearch(v); }, 250);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMegas();
    closeLayer($('[data-mn3-drawer]'));
    closeLayer($('[data-mn3-search]'));
  });
})();
